import { get } from './apiUtil';
import { AxiosResponse } from 'axios';
import Config from '../model/config';

export function getProfileProperties(): Promise<Config> {
  return new Promise((resolve, reject) => {
    get('/api/config/profileProperties')
      .then((response: AxiosResponse) => resolve(response.data))
      .catch((e) => reject(e));
  });
}
